import axios_ from "../utils/axios";

/**
 * 国家货币代码（ISO 4217格式）
 * @returns {Promise<*>}
 */
export function getCurrencyList() {
  return axios_("GET", "api/pandagpt/v1/currency/lists", {
    page: 1,
    page_num: 300,
  });
}
